import { Theme } from '@mui/material';


const Select = (theme: Theme) => {
  return {
    MuiSelect: {
      styleOverrides: {
        root: {
          '& fieldset': {
            borderColor: '#e2e8f0',
            borderRadius: '10px',
          },
          '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main,
          },
        },
      },
    },
  };
};

export default Select;
